import { Button, Flex, Heading, Text } from '@chakra-ui/react';

import NextLink from 'next/link';

type Props = {
  title?: string;
  description?: string;
};

export const UnknownErrorContext: React.FC<Props> = (props: Props) => {
  return (
    <Flex flexDir="column">
      <Flex flexDir="column" mt={4} mb={8} mx={4} alignItems="center">
        <Heading size="lg">
          {props.title ?? '予期せぬエラーが発生しました'}
        </Heading>
      </Flex>
      <Flex flexDir="column" my={8} mx={4} alignItems="center">
        <Text>
          {props.description ??
            'ページのリロードを行なってください。解決しない場合は画面上部のヘッダーよりイベントのホームページに戻り、もう一度やり直してください'}
        </Text>
      </Flex>
      <Flex flexDir="column" my={8} mx={4} alignItems="center">
        <NextLink href={'/e'}>
          <Button>リロードする</Button>
        </NextLink>
      </Flex>
    </Flex>
  );
};
